import { useState, useEffect, useContext } from "react";
import { Box, Typography, Button, Modal, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { DataContext } from "../contexts/DataProvider";

const modalStyle = {
  position: "fixed" as const,
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  bgcolor: "rgba(0,0,0,0.2)",
  zIndex: 2000,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backdropFilter: "blur(2px)",
};

const cardStyle = {
  width: 650,
  minHeight: 350,
  p: 4,
  borderRadius: 3,
  boxShadow: 6,
  textAlign: "center" as const,
  background: "#fff",
  display: "flex",
  flexDirection: "column" as const,
  justifyContent: "space-evenly",
};

export default function FreeTierLimitModal() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { login } = useContext(DataContext);
  const isOrgAdmin = login?.data?.role === "orgadmin";

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener("free-tier-limit-reached", handler);
    return () => window.removeEventListener("free-tier-limit-reached", handler);
  }, []);

  const handleClose = () => {
    setOpen(false);
      };

  const handleUpgrade = () => {
    setOpen(false);
        navigate("/admin?tab=payments");
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={modalStyle}>
        <Paper sx={cardStyle}>
          <Box mb={2}>
            <Box
              sx={{
                width: 60,
                height: 60,
                borderRadius: "50%",
                bgcolor: "#fff3e0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mx: "auto",
                mb: 2,
              }}
            >
              <svg width="32" height="32" fill="none" viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="10" fill="#ed6c02" opacity="0.15" />
                <path
                  d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
                  fill="#ed6c02"
                />
              </svg>
            </Box>

            <Typography variant="h6" fontWeight={700} mb={1}>
              Client Limit Reached
            </Typography>

            <Typography variant="body1" color="text.secondary">
              {isOrgAdmin
                ? "You have reached the 5-client limit on the free tier. Upgrade your organisation to get full access and add unlimited clients."
                : "Your organisation has reached the 5-client limit on the free tier. Please contact your administrator to upgrade."}
            </Typography>
          </Box>

          <Button
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mb: 1, fontWeight: 600, height: 56 }}
            onClick={isOrgAdmin ? handleUpgrade : handleClose}
          >
            {isOrgAdmin ? "Upgrade Now" : "Okay"}
          </Button>

          {isOrgAdmin && (
            <Button
              variant="text"
              color="inherit"
              fullWidth
              onClick={handleClose}
              sx={{ fontWeight: 500, height: 48 }}
            >
              Not now
            </Button>
          )}
        </Paper>
      </Box>
    </Modal>
  );
}
